/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/destructuring-assignment */

import React from 'react'

import { CleaveOptions } from 'cleave.js/options'
import Cleave from 'cleave.js/react'

type CleaveInputProps = React.InputHTMLAttributes<HTMLInputElement> &
  CleaveOptions & { inputRef?: React.ComponentProps<typeof Cleave>['htmlRef'] }

export default function MaskedTextField({ inputRef, ...props }: CleaveInputProps) {
  return (
    <Cleave
      {...props}
      htmlRef={inputRef}
      options={{ blocks: props.blocks, delimiter: props.delimiter }}
    />
  )
}
